import {
  AppstoreOutlined,
  TeamOutlined,
  SwapOutlined,
  DollarOutlined,
  WalletOutlined,
  CreditCardOutlined,
  UserOutlined,
  BankOutlined,
  MessageOutlined,
  SettingOutlined,
} from "@ant-design/icons";

export const sidebarItems = [
  {
    key: "/dashboard",
    icon: <AppstoreOutlined />,
    label: "Dashboard",
    module: "dashboard",
  },
  {
    key: "/delivery-partners",
    icon: <TeamOutlined />,
    label: "Delivery Partners",
    module: "deliveryPartners",
  },
  {
    key: "/transactions",
    icon: <SwapOutlined />,
    label: "Transactions",
    module: "transactions",
  },
  {
    key: "/cash-cod",
    icon: <DollarOutlined />,
    label: "Cash & COD",
    module: "cashCOD",
  },
  {
    key: "/payroll-expenses",
    icon: <WalletOutlined />,
    label: "Payroll & Expenses",
    module: "payrollExpenses",
  },
  {
    key: "/payouts",
    icon: <CreditCardOutlined />,
    label: "Payouts",
    module: "payouts",
  },
  {
    key: "/users-leaves",
    icon: <UserOutlined />,
    label: "Users & Leaves",
    module: "usersLeaves",
  },
  {
    key: "/accounts",
    icon: <BankOutlined />,
    label: "Accounts",
    module: "accounts",
  },
  {
    key: "/communications",
    icon: <MessageOutlined />,
    label: "Communications",
    module: "communications",
  },
  {
    key: "/settings",
    icon: <SettingOutlined />,
    label: "Settings",
    module: "settings",
  },
];
